<template>
    <div class="white-box plan-selection__plan text-black">
        <ul class="choose-plan">
            <li class="choose-plan__item">
                <span class="choose-plan__item--paymentType">Net Banking</span>
                <span class="choose-plan__item--text darken">Transfer via IMPS, NEFT or RTGS</span>
            </li>
            <li class="choose-plan__item">
                <span class="choose-plan__item--paymentType">Amount to be deposited</span>
                <span class="font-weight-medium">&#8377;{{selectedPortfolio.investmentAmount/100}}</span>
            </li>
            <li class="choose-plan__item" v-for="(item, index) in paymentDetails" :key="index">
                <span class="choose-plan__item--paymentType">
                    <small class="d-block">{{item.label}}</small>
                    <p ref="paymentDetails">{{item.value}}</p>
                </span>
                <span class="choose-plan__item--text" @click="copyToClipboard(index)">
                    <i class="sprite icon-copy"></i>
                </span>
            </li>
        </ul>
    </div>
</template>
<script>
const { copyToClipboard } = require('@/util/util.js')

export default {
    name: 'DetailsCard',
    props: {
        paymentDetails: Array,
        selectedPortfolio: Object
    },
    methods: {
        copyToClipboard (index) {
            copyToClipboard(this.$refs.paymentDetails[index])
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/components/dashboard/dashboard.scss";

.portfolioInfo {
    width: calc(100% - 65px);
}

.darken {
    color: gray
}
</style>
